<template>
  <div>
    <div>
      <template v-if="isPrintWorkFlow">
        <v-row>
          <v-col cols="12">
            <p class="title-workflow">Aprobadores/Resolutor</p>
          </v-col>
        </v-row>

        <v-row v-if="isPrintWorkFlow" class="text-center">
          <v-col cols="12">
            <v-sheet>
              <v-chip-group
                mandatory
                :class="$vuetify.breakpoint.xs
                  ? 'workflow--form'
                  : 'workflow--form__initial'"
              >
                <template v-for="(work, i) in listTotal">
                  <v-chip :key="`chip-${i}`"
                    label :color="'primary'"
                    class="chip-workflow"
                  >
                    <span class="white--text">{{ work }}</span>
                  </v-chip>
                  <v-icon v-if="i < listTotal.length - 1" :key="`icon-${i}`">
                    mdi-arrow-right
                  </v-icon>
                </template>
              </v-chip-group>
            </v-sheet>
          </v-col>
        </v-row>
      </template>

      <p v-if="loadingPrintWorkFlow" class="ml-3" >Cargando Flujo de aprobación...</p>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isPrintWorkFlow: false,
      loadingPrintWorkFlow: false,
      workplaceId: '',
      elementId: '',
      elementForUpdate: [],
      elementForInsert: [],
      approverZeroName: [],
      listWorkFlow: [],
      listTotal: [],
      isWorkFlow: false,
    };
  },
  async created() {
    this.loadingPrintWorkFlow = true;
    this.workplaceId = localStorage.getItem('workplaceId');

    const { path } = this.$route;
    const elementId = path.substring(path.lastIndexOf('/') + 1);
    this.elementId = elementId;

    try {
      this.isWorkFlow = await this.isworkFlow(this.elementId);
    } catch (err) {
      console.log(err);
    }

    if (this.isWorkFlow) {
      try {
        const response = await this.searchWorkFlow(this.elementId, this.workplaceId);

        this.listWorkFlow = this.getNameWorkflow(response.list);
      } catch (err) {
        console.log(err);
      }

      this.elementForInsert = JSON.parse(localStorage.getItem('elementForInsert')) || [];
      this.elementForUpdate = JSON.parse(localStorage.getItem('elementForUpdate')) || [];

      if (this.elementForInsert.props.length === 0) {
        this.listTotal = this.listWorkFlow;
        this.isPrintWorkFlow = true;
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.elementForInsert.props
          .forEach((element) => {
            if (!element?.special_values?.workflowDependency
              && element.special_values.workflowName) {
              this.approverZeroName.push(element.special_values.workflowName);
              this.listTotal = this.approverZeroName.concat(this.listWorkFlow);
              this.isPrintWorkFlow = true;
            } else {
              this.isPrintWorkFlow = false;
            }
          });
      }
    }

    this.loadingPrintWorkFlow = false;

    // Update Centro
    this.$root.$on('Updatesearch', async (workplace) => {
      if (this.isWorkFlow && workplace.value) {
        const { value: workplaceId } = workplace;
        this.loadingPrintWorkFlow = true;

        try {
          const response = await this.searchWorkFlow(this.elementId, workplaceId);
          if (response?.list?.length > 0) {
            this.listTotal = [];
            this.listWorkFlow = [];
            this.listWorkFlow = this.getNameWorkflow(response.list);
          }

          if (this.elementForInsert.props.length === this.approverZeroName.length) {
            this.listTotal = this.approverZeroName.concat(this.listWorkFlow);
            this.isPrintWorkFlow = true;
          }
        } catch (err) {
          console.log(err);
        }

        this.loadingPrintWorkFlow = false;
      }
    });

    // Update Formulario
    this.$root.$on('UpdateFiledForm', async (dataFieldChange) => {
      if (!this.isWorkFlow) {
        return;
      }
      const { props: approversForInsert } = this.elementForInsert;

      if (approversForInsert.length > 0) {
        // Campo modificado
        let nameApprover = '';
        const { dataForm, alias: fieldAlias } = dataFieldChange;
        const fieldChange = dataForm[fieldAlias]?.item || dataForm[fieldAlias] || {};
        const { id: fieldDependance } = fieldChange;

        // Campo WF con dependencia
        const elementDependance = approversForInsert.filter((approver) => (
          approver.special_values.workflowIsDependency));

        if (fieldChange.value && elementDependance.length > 0
          && elementDependance[0]?.alias === fieldAlias) {
          const app0 = approversForInsert.filter((approver) => (
            approver.special_values.workflowDependency === fieldDependance)) || [];

          if (app0.length > 0) {
            this.approverZeroName = [];
            nameApprover = app0[0].special_values.workflowName;
            this.approverZeroName.push(nameApprover);
            this.listTotal = this.approverZeroName.concat(this.listWorkFlow);
            this.isPrintWorkFlow = true;
          } else {
            this.isPrintWorkFlow = false;
          }
        } else if (approversForInsert.length > 0
          && approversForInsert[0].alias === fieldAlias
          && Object.entries(fieldChange).length !== 0) {
          if (fieldChange.value) {
            nameApprover = fieldChange.value;
          } else {
            const {
              middle_name: middleName, last_name: lastName, first_name: firstName, name,
            } = fieldChange;
            nameApprover = `${ middleName || name || '' } ${ lastName || '' } ${ firstName || '' }`;
          }
          this.approverZeroName = [];
          this.approverZeroName.push(nameApprover);
          this.listTotal = this.approverZeroName.concat(this.listWorkFlow);
          this.isPrintWorkFlow = true;
        }

        if (elementDependance.length > 0 && !dataForm[elementDependance[0]?.alias]) {
          this.isPrintWorkFlow = false;
        }
      } else {
        this.listTotal = this.listWorkFlow;
        this.isPrintWorkFlow = true;
      }
    });
  },
  methods: {
    async isworkFlow(elementId) {
      const client = this.$api.getClient('search');
      try {
        const response = await client.search({
          target: 'namedquery',
          entity: 'sqlRequestCrHasWorkflowTemplate',
          filters: {
            element: elementId,
          },
        });
        return response.list.length > 0;
      } catch (err) {
        console.log('reject resolve message dialog:', err.message);
        return err;
      }
    },
    async searchWorkFlow(elementId, workplaceId) {
      const client = this.$api.getClient('search');
      try {
        const response = await client.search({
          target: 'namedquery',
          entity: 'ticketApprovalWorkflowTemplate',
          filters: {
            element: elementId,
            location: workplaceId,
          },
        });

        return response;
      } catch (err) {
        console.log('reject resolve message dialog:', err.message);
        return err;
      }
    },
    getNameWorkflow(listWorkFlowResponse) {
      return listWorkFlowResponse.map((element) => element.approvalworkflowtemplate.contact.name);
    },
    setApproverZeroName(approversForInsert, nameapprover) {
      this.approverZeroName = [];
      this.approverZeroName.push(nameapprover);

      if (approversForInsert.length === this.approverZeroName.length) {
        this.listTotal = this.approverZeroName.concat(this.listWorkFlow);
        this.isPrintWorkFlow = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .workflow--form__initial .v-slide-group__content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  ::v-deep .workflow--form .v-slide-group__content{
    display: flex;
    flex-direction: column;
  }

  ::v-deep .workflow--form .v-icon.v-icon {
    transform: rotate(90deg);
  }

  .title-workflow {
    margin: 0;
  }
</style>
